// extracted by mini-css-extract-plugin
export default {"searchInput":"searchInput_searchInput__PBf9j"};